module.exports = __webpack_public_path__ + "img/openDoor.88e7b186.png";